import { useModal } from '../context/ModalContext';

const Modal = () => {
  const { isOpen, closeModal, modalContent,modalTitle } = useModal();

  if(!isOpen){
    return null;
  }
  return (
    <div className='bg-[#15161659] fixed w-full h-full top-0 left-0 right-0 bottom-0 z-50'>
        <div className="rounded-lg absolute bg-white border w-[400px]  top-[30px] left-1/2 transform -translate-x-1/2 z-50">
            <div className='grid grid-cols-2 p-2 border-b-[1px] border-[#E1E3E1]'>
                <div className=''>{modalTitle}</div>
                <div className='text-right'>
                    <button type='button'  onClick={closeModal}>
                        <img className="w-[12px]" src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e" alt='logo'/>
                    </button>
                </div>
            </div>
            <div className='w-full p-2 max-h-[calc(85vh-60px)] overflow-y-auto scrollbar-hide'>
                {modalContent}
            </div>
            
        </div>
    </div>
  );
};

export default Modal;
